import { render, staticRenderFns } from "./PatientInformation.vue?vue&type=template&id=9e0c1f90&"
import script from "./PatientInformation.vue?vue&type=script&lang=js&"
export * from "./PatientInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports